import Constants from '@/Constants';
import { Attachment } from '@/models/Attachment';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    getAttachmentListFailure,
    getAttachmentListSuccess,
    postAttachmentFailure,
    postAttachmentSuccess,
    putAttachmentFailure,
    putAttachmentSuccess,
    removeAttachmentFailure,
    removeAttachmentSuccess,
} from './action';
import { AttachmentRequest, AttachmentsTypes } from './types';

export function* getAttachmentListRequest(action: PayloadAction<AttachmentsTypes.GET_ATTACHMENTS_REQUEST, AttachmentRequest>) {
    try {
        const queryParams: string = `/${action.payload.entityId}?locale=${action.payload.locale}`;
        const response = yield call(http.get, Constants.ATTACHMENTS_CONTENT_URI + queryParams);
        yield put(getAttachmentListSuccess(response.data));
    } catch (error) {
        yield put(getAttachmentListFailure());
    }
}

export function* removeAttachmentRequest(action: PayloadAction<AttachmentsTypes.REMOVE_ATTACHMENT_REQUEST, number>) {
    try {
        yield call(http.delete, Constants.ATTACHMENTS_DELETE_URI.replace('%s', action.payload.toString()));
        yield put(removeAttachmentSuccess(action.payload));
    } catch (error) {
        yield put(removeAttachmentFailure(error));
    }
}

export function* putAttachment(action: PayloadAction<AttachmentsTypes.PUT_ATTACHMENT_REQUEST, AttachmentRequest>) {
    try {
        yield call(http.put, Constants.ATTACHMENTS_URI, action.payload);
        yield put(putAttachmentSuccess(action.payload));
    } catch (err) {
        yield put(putAttachmentFailure(err));
    }
}

export function* postAttachmentRequest(action: PayloadAction<AttachmentsTypes.POST_ATTACHMENT_REQUEST, Attachment>) {
    try {
        const { data } = yield call(http.post, Constants.ATTACHMENTS_URI, action.payload);
        yield put(postAttachmentSuccess(data));
    } catch (error) {
        yield put(postAttachmentFailure());
    }
}
